// extracted by mini-css-extract-plugin
export default {"select":"Quotes_select__WcvCi","container":"Quotes_container__fp6Ns"};